import React, { Component, Fragment } from "react";
import {
    TextField,
    ListItem,
    ListItemText,
    Select,
    Typography
} from "@material-ui/core";
import styled from "styled-components";

import { TEAM_USER_ROLES, TEAM_USER_LICENSE_STATUS } from "../../../common/constants";
import Icon from "js/react/components/Icon";
import { EMAIL_VALIDATION_REGEX } from "js/react/constants";

const StyledAddTeamMemberContainer = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 300px;
  align-items: center;
  margin-top: 5px;
`;

const EmailInput = styled(TextField)`
    input {
      font-size: 14px;
      ::placeholder {
        font-weight: 900;
      }
    }
    //its necessary to add important to prevent the style override from MuiFormControl-root
    margin: 0 5px 5px 0 !important;
    min-width: 270px !important;
`;

const AddMemberSpan = styled.span`
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.26);
  font-weight: bolder;
  font-size: 12px;
`;

const AddMemberIconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

const BlockTypography = styled(Typography)`
  display: block;
`;

const roleOptions = [
    { label: "Owner", value: TEAM_USER_ROLES.OWNER, license: TEAM_USER_LICENSE_STATUS.TEAM_PRO, description: "Manages members, team slides and theme" },
    { label: "Librarian", value: TEAM_USER_ROLES.LIBRARIAN, license: TEAM_USER_LICENSE_STATUS.TEAM_PRO, description: "Manages team slides and theme" },
    { label: "Pro Member", value: TEAM_USER_ROLES.MEMBER_LICENSED, license: TEAM_USER_LICENSE_STATUS.TEAM_PRO, description: "Has access to Beautiful.ai Pro features" },
    { label: "Free Member", value: TEAM_USER_ROLES.MEMBER, license: TEAM_USER_LICENSE_STATUS.TEAM_PRO, description: "Limited to basic features" }
];

export default class AddTeamMember extends Component {
    renderRoleSelect(member) {
        const { onMemberUpdate, billingTerm } = this.props;

        let selectedIndex;
        switch (member.role) {
            case TEAM_USER_ROLES.OWNER:
                selectedIndex = 0;
                break;
            case TEAM_USER_ROLES.LIBRARIAN:
                selectedIndex = 1;
                break;
            case TEAM_USER_ROLES.MEMBER_LICENSED:
                selectedIndex = 2;
                break;
            case TEAM_USER_ROLES.MEMBER:
                selectedIndex = 3;
                break;
        }

        return (
            <RoleSelectComponent
                propKey="role"
                data={member}
                options={roleOptions}
                onSelect={onMemberUpdate}
                selectedIndex={selectedIndex}
                billingTerm={billingTerm}
            />
        );
    }

    isTextFieldInvalid(member) {
        const { members, existTeamMembersObj = {} } = this.props;
        if (member.email.length === 0) {
            return false;
        }
        return member.email.length > 1 && !member.email.match(EMAIL_VALIDATION_REGEX) ||
            !!existTeamMembersObj[member.email.toLowerCase()] ||
            members.filter(m => m.email.length > 0 && m.email === member.email.toLowerCase()).length > 1;
    }

    checkIfMemberListInvalid = () => {
        const { members, existTeamMembersObj = {} } = this.props;
        return members.some(member => this.isTextFieldInvalid(member));
    }

    handleAddMemberClick = () => {
        const { onAddMemberClick } = this.props;
        const isMemberListInvalid = this.checkIfMemberListInvalid();
        if (isMemberListInvalid) {
            return;
        }
        onAddMemberClick();
    }

    render() {
        const { members, onMemberUpdate, onRemoveMemberClick, classes } = this.props;
        const isMemberListInvalid = this.checkIfMemberListInvalid();

        return (
            <div>
                {
                    members.map((member, index) => {
                        return (
                            <StyledAddTeamMemberContainer key={member.id}>
                                <div>
                                    {(index === 0) && <div className="label">Invite your team members</div>}
                                    <EmailInput
                                        disabled={member.isDisabled}
                                        type="email"
                                        variant="outlined"
                                        placeholder="Email"
                                        value={member.email}
                                        onChange={event => onMemberUpdate(member.id, "email", event.target.value)}
                                        error={this.isTextFieldInvalid(member)}
                                    />
                                </div>
                                <div>
                                    {(index === 0) && <div className="label">Assign a role</div>}
                                    {this.renderRoleSelect(member)}
                                </div>

                                {
                                    (index > 0) ? (
                                        <Icon
                                            iconName="clear"
                                            onClick={() => onRemoveMemberClick(member.id)}
                                            style={{ fontSize: "20px", color: "#bbb", cursor: "pointer" }}
                                        />
                                    ) : <div style={{ width: "20px" }}></div>
                                }
                            </StyledAddTeamMemberContainer>
                        );
                    })
                }
                <AddMemberIconContainer>
                    <Icon
                        iconName="add_circle"
                        onClick={this.handleAddMemberClick}
                        style={{ fontSize: "30px", color: isMemberListInvalid ? "#e0e0e0" : "#11a9e2", paddingRight: 5, cursor: isMemberListInvalid ? "not-allowed" : "pointer" }}
                    />
                    <AddMemberSpan>Add Another</AddMemberSpan>
                </AddMemberIconContainer>
            </div>
        );
    }
}

class RoleSelectComponent extends Component {
    handleSelectChange = event => {
        const { onSelect, data } = this.props;
        onSelect && onSelect(data.id, "role", event.target.value);
    };

    render() {
        const { options, selectedIndex, billingTerm, data } = this.props;

        return (
            <Select
                disabled={data.isDisabled}
                value={options[selectedIndex].label}
                variant="outlined"
                style={{
                    width: 115,
                    margin: "0 5px 5px"
                }}
                renderValue={() => (
                    <Typography component="span" style={{ textTransform: "capitalize", fontSize: "12px", fontWeight: 900 }} color="textPrimary">
                        {options[selectedIndex].label}
                    </Typography>
                )}
                onChange={this.handleSelectChange}
            >
                {options.map((option, index) => (
                    <ListItem
                        value={option.value}
                        key={index}
                        button
                    >
                        <ListItemText
                            primary={
                                <BlockTypography style={{ fontWeight: 900 }} component="span" color={(index === selectedIndex) ? "primary" : "textPrimary"}>
                                    {option.label}
                                </BlockTypography>
                            }
                            secondary={
                                <>
                                    <BlockTypography component="span" color={(index === selectedIndex) ? "primary" : "textSecondary"}>
                                        {option.description}
                                    </BlockTypography>
                                </>
                            }
                            style={{ whiteSpace: "nowrap" }}
                        />
                    </ListItem>
                ))}
            </Select>
        );
    }
}
